import { PREVIEW_MODE } from '$lib/global/constants';

import { base } from '$app/paths';

export const getDataBaseUrl = () => {
    if (!PREVIEW_MODE) {
        return `${base}/data`;
    }

    const lemonToolApiBaseUrl = import.meta.env.VITE_LEMON_TOOL_API_BASE;

    if (!lemonToolApiBaseUrl) {
        throw new Error('VITE_LEMON_TOOL_API_BASE is not defined');
    }

    // Ensure the base path includes a valid campaign ID
    const campaignIdMatch = base.match(/\/funnel\/([^/]+)\//);

    if (!campaignIdMatch) {
        throw new Error(`Invalid base path: Unable to extract campaign ID from '${base}'`);
    }
    const campaignId = campaignIdMatch[1];

    return `${lemonToolApiBaseUrl}/campaigns/${campaignId}/preview/data`;
};
